function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#E1E5E9",
  d: "M6.97 6l4.91 4.91-.97.97L6 6.97l-4.909 4.91-.97-.97L5.028 6 .12 1.09l.971-.97 4.91 4.91L10.908.12l.971.97L6.97 6z"
});

var SvgRemove = function SvgRemove(props) {
  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _ref);
};

export default SvgRemove;